import { EntityBase } from "./entityBase";
import { Product } from "./product";
import { Order } from "./order";
import { OrderItemText } from "./order.item.text";
import { OrderItemProductOption } from "./order.item.product.option";
import { Image } from './image'

export class OrderItem extends EntityBase {
    public Quantity: number;
    public Price: number;
    public ProductId: number;
    public Product: Product;
    public OrderId: number;
    public Order: Order;
    public Preview: string;
    public OriginalImages: Image[];
    public UsingImages: Image[];
    public OrderItemTexts: OrderItemText[];
    public OrderItemProductOptions: OrderItemProductOption[];
    public Canvas: any;
    public PrintUnitPrice: number
    public ProductUnitPrice: number
    public TotalPrintPrice: number
    public TotalProductPrice: number
    public UnitPrice: number
}